import { IcChevronBackNegative, IcClose, IcSaveFilled } from '@assets/icons/24x24';
import { ButtonGroup, HStack, Icon, IconButton, VStack } from '@chakra-ui/react';
import { ButtonWithIcon } from '@components/ui/buttonToggle/ButtonWithIcon';
import { ReactNode } from 'react';

interface CockpitPageLayoutProps {
  dialog?: ReactNode;
  breadcrumbs?: ReactNode;
  actions?: ReactNode;
  children?: ReactNode;
  onBack?: () => void;
  onSave?: () => void;
  isSaving?: boolean;
  isSaveDisabled?: boolean;
  showActionBar?: boolean;
  hideCancel?: boolean;
}

export function CockpitEditorLayout({
  dialog,
  breadcrumbs,
  onBack,
  onSave,
  actions,
  children,
  isSaving = false,
  isSaveDisabled = false,
  showActionBar = true,
  hideCancel = false,
}: Readonly<CockpitPageLayoutProps>) {
  const showSaveButton = Boolean(onSave);
  const showBackButton = Boolean(onBack);

  return (
    <VStack boxSize="100%" gap={0.25}>
      {dialog}
      {showActionBar && (
        <HStack width="100%" gap={0} userSelect="none" backgroundColor="neutral.900">
          {showBackButton && (
            <IconButton variant="transparent" boxSize="56px" aria-label="back" onClick={onBack}>
              <Icon as={IcChevronBackNegative} boxSize="24px" />
            </IconButton>
          )}
          {breadcrumbs}
          <ButtonGroup backgroundColor="neutral.900" marginLeft="auto" gap={0.25} height="100%">
            {actions}
            {showSaveButton && (
              <ButtonWithIcon
                variant="headOption"
                loading={isSaving}
                aria-label="save"
                data-active={!isSaveDisabled}
                disabled={isSaveDisabled}
                onClick={onSave}
                label="global.save"
                icon={<Icon as={IcSaveFilled} boxSize="24px" />}
              />
            )}
            {showBackButton && !hideCancel && (
              <ButtonWithIcon
                variant="headOption"
                aria-label="cancel"
                onClick={onBack}
                label="global.cancel"
                icon={<Icon as={IcClose} boxSize="24px" />}
              />
            )}
          </ButtonGroup>
        </HStack>
      )}
      <VStack width="100%" flex={1} minHeight={0} gap={0.25}>
        {children}
      </VStack>
    </VStack>
  );
}
